module.exports = __webpack_public_path__ + "redcoon.png?813a3b8c38b15e748cfda59e25979228";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/redcoon.png
// module id = 1000
// module chunks = 2